var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4286 15.1429H2.57143C1.70321 15.1429 1 14.4397 1 13.5714V7.28572C1 6.41751 1.70321 5.71429 2.57143 5.71429H10.4286C11.2968 5.71429 12 6.41751 12 7.28572V13.5714C12 14.4397 11.2968 15.1429 10.4286 15.1429Z",
    stroke: "currentColor",
    strokeWidth: 1.17857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.0707V10.0357",
    stroke: "currentColor",
    strokeWidth: 1.17857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91613 9.02978C7.14626 9.25991 7.14626 9.63302 6.91613 9.86315C6.686 10.0933 6.31288 10.0933 6.08275 9.86315C5.85262 9.63302 5.85262 9.25991 6.08275 9.02978C6.31288 8.79965 6.686 8.79965 6.91613 9.02978Z",
    stroke: "currentColor",
    strokeWidth: 1.17857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35742 5.71429V4.14286C3.35742 2.40721 4.76464 1 6.50028 1C8.23592 1 9.64314 2.40721 9.64314 4.14286V5.71429",
    stroke: "currentColor",
    strokeWidth: 1.17857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.103199de8af578d160c7d7e1ba2a8176.svg";
export { ForwardRef as ReactComponent };